<template>
	<b-modal ref="addCustomersSummaryResult" id="addCustomersSummaryResult" :header-bg-variant="'secondary'" no-close-on-esc no-close-on-backdrop hide-backdrop>
      <template slot="modal-header" slot-scope="{ close }">
        <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'users']" size="1x" class="mr-2"/> {{t('bulkAddUpdateCustomersSuccess', 'bulkAddUpdateCustomersSuccess')}}</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close();hideBackdrop();"><span aria-hidden="true" class="text-light">X</span></button>
      </template>
      <template v-slot:default>
        <template v-if="resultData">
          <div class="col-12 p-2">
            <template v-if="resultData.successAPI && resultData.successAPI.length > 0">
              <p class="font-weight-bold mb-1">{{ t('apiCustomersProcessedConfirmation', 'apiCustomersProcessedConfirmation') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.successAPI" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.addedCustomers && resultData.report.addedCustomers.length > 0">
              <p class="font-weight-bold mb-1">{{ t('arAddedNewCustomersLabel', 'arAddedNewCustomersLabel') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.addedCustomers" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.unchangedCustomers && resultData.report.unchangedCustomers.length > 0">
              <p class="font-weight-bold mb-1">{{ t('arCustomersDataNotChangedLabel', 'arCustomersDataNotChangedLabel') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.unchangedCustomers" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.updatedCustomers && resultData.report.updatedCustomers.length > 0">
              <p class="font-weight-bold mb-1">{{ t('arUpdatedCustomersLabel', 'arUpdatedCustomersLabel') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.updatedCustomers" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.failedCustomers && resultData.failedCustomers.length > 0">
              <p class="font-weight-bold mb-1">{{ t('failedCustomerUpdateCreateError', 'failedCustomerUpdateCreateError') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.failedCustomers" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.failedAPI && resultData.failedAPI.length > 0">
              <p class="font-weight-bold mb-1">{{ t('apiCallFailedForRefs', 'apiCallFailedForRefs') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.failedAPI" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.failedTokenAPI && resultData.failedTokenAPI.length > 0">
              <p class="font-weight-bold mb-1">{{ t('tokenCallFailedForRefs', 'tokenCallFailedForRefs') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.failedTokenAPI" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.wrongCountryCodeCustomer && resultData.report.wrongCountryCodeCustomer.length > 0">
              <p class="font-weight-bold mb-1">{{ t('customerWrongCountryCode', 'customerWrongCountryCode') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.wrongCountryCodeCustomer" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.wrongCurrencyCodeCustomer && resultData.report.wrongCurrencyCodeCustomer.length > 0">
              <p class="font-weight-bold mb-1">{{ t('customerWrongCurrencyCode', 'customerWrongCurrencyCode') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.wrongCurrencyCodeCustomer" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.emailsPrimaryInvalid && resultData.report.emailsPrimaryInvalid.length > 0">
              <p class="font-weight-bold mb-1">{{ t('invalidPrimaryEmailFormat', 'invalidPrimaryEmailFormat') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.emailsPrimaryInvalid" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.report.wrongReferenceCustomers && resultData.report.wrongReferenceCustomers.length > 0">
              <p class="font-weight-bold mb-1">{{ t('customerWrongReference', 'customerWrongReference') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.report.wrongReferenceCustomers" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.errorFieldsErrors && resultData.errorFieldsErrors.length > 0">
              <p class="font-weight-bold mb-1">{{ t('invalidFieldValueProvided', 'invalidFieldValueProvided') }}</p>
              <div class="col-12">
                <li v-for="ref in resultData.errorFieldsErrors" :key="ref">{{ ref }}</li>
              </div>
              <hr class="mb-1 mt-1">
            </template>
            <template v-if="resultData.arErrors && Object.keys(resultData.arErrors).length > 0">
              <p class="font-weight-bold mb-2">{{ t('customerAdditionalApiErrors', 'customerAdditionalApiErrors') }}</p>
              <div class="col-12 px-0">
                <div class="col-12 px-0" v-for="(error, ref) in resultData.arErrors" :key="ref">
                  <p class="font-weight-bold mb-0 mt-1">{{ ref }}</p>
                  <template v-if="error && error.length > 0">
                    <li class="ml-3" v-for="er in error" :key="er">{{ er }}</li>
                  </template>
                  <hr class="mb-1 mt-1">
                </div>
              </div>
            </template>
            <!--<template v-if="resultData.fileUploadStatus">
              <div class="col-12 px-0 text-left">
                <span class="font-weight-bold upload-success-text" v-if="resultData.fileUploadStatus == 'success'">{{ t('s3FileUploadSuccess', 's3FileUploadSuccess') }}</span>
                <span class="font-weight-bold upload-error-text" v-else-if="resultData.fileUploadStatus == 'error'">{{ t('s3FileUploadError', 's3FileUploadError') }}</span>
              </div>
              <hr class="mb-1 mt-1">
            </template>-->
          </div>
        </template>
        <template v-else>
          <h3>{{ t('noInformationAvailable', 'noInformationAvailable') }}</h3>
        </template>
      </template>
      <template v-slot:modal-footer="{ close }">
        <button aria-label="Close" data-dismiss="modal" class="btn btn-primary" type="button" @click="routeToCustomers()">
          <fontAwesomeIcon :icon="['fa', 'users']" class="text-light mr-2"/>{{ t('manageCustomers', 'manageCustomers')}}
        </button>
        <button aria-label="Close" data-dismiss="modal" class="btn btn-secondary" type="button" @click="close();hideBackdrop();">
          <fontAwesomeIcon :icon="['fa', 'times']" class="text-light mr-2"/>{{ t('closeButtonText', 'closeButtonText')}}
        </button>
      </template>
    </b-modal>
</template>

<script>
export default {
  name: 'ModalAddCustomersResult',
  props: ['stats'],
  data() {
    return {
      addResult: this.stats
    }
  },
  methods: {
    hideBackdrop() {
      this.$parent.modalOpen = false
    },
    routeToCustomers() {
      this.$router.push({ name: 'manage_customers'})
    },
	},
  computed: {
    resultData() {
      if(this.$props.stats) {
        return this.$props.stats
      }
      return false
    }
  }
}
</script>

<style scoped>
.upload-success-text {
  color: #047bf8;
}

.upload-error-text {
  color: rgb(213, 62, 62);
}
</style>